import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { fmtDate, fmtHorodatage } from '@/lib/lmdsJours';

// 🧾 Phase 3A : historique des jours admissibles (y compris supprimés, marqués).
export function TableJoursAdmissibles({ jours, nomsInstallateurs, onModifier, onSupprimer }) {
  if (!jours.length) return <p className="text-sm text-slate-500 p-3" data-testid="jours-vide">Aucun jour admissible pour cette sélection.</p>;
  return (
    <table className="w-full text-sm" data-testid="table-jours-admissibles">
      <thead className="text-xs text-slate-500 text-left">
        <tr><th className="p-2">Installateur</th><th className="p-2">Date</th><th className="p-2">Note</th><th className="p-2">Ajouté par</th><th className="p-2">Modifié le</th><th className="p-2">Statut</th><th className="p-2"></th></tr>
      </thead>
      <tbody>
        {jours.map((j) => (
          <tr key={j.id} className={`border-t ${j.statut === 'supprime' ? 'opacity-60' : ''}`} data-testid={`jour-${j.id}`}>
            <td className="p-2">{nomsInstallateurs[j.installateur_id] || j.installateur_id}</td>
            <td className="p-2">
              <span className={j.statut === 'supprime' ? 'line-through' : ''}>{fmtDate(j.date)}</span>
              {j.avertissement && <span className="block text-xs text-amber-700" data-testid={`jour-avert-${j.id}`}>{j.avertissement}</span>}
            </td>
            <td className="p-2">{j.note || '—'}</td>
            <td className="p-2 text-xs">{j.cree_par || '—'}</td>
            <td className="p-2 text-xs">{fmtHorodatage(j.updated_at)}</td>
            <td className="p-2">
              <Badge variant={j.statut === 'actif' ? 'default' : 'secondary'} data-testid={`jour-statut-${j.id}`}>{j.statut === 'actif' ? 'Actif' : `Supprimé le ${fmtHorodatage(j.supprime_le)}`}</Badge>
            </td>
            <td className="p-2 text-right whitespace-nowrap">
              {j.statut === 'actif' && (
                <>
                  <Button size="sm" variant="outline" className="mr-1" data-testid={`jour-modifier-${j.id}`} onClick={() => onModifier(j)}>Modifier</Button>
                  <Button size="sm" variant="destructive" data-testid={`jour-supprimer-${j.id}`} onClick={() => onSupprimer(j)}>Supprimer</Button>
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
